/**
 * A basic mapper and reducer to build custom object
 */

export const basicReducer = (entities, entity) => ({ ...entities, [entity.id]: entity.label });
export const basicMapper = (values, reducer = basicReducer, initialValues = {}) =>
  Object.values(values).reduce(reducer, initialValues);
